// Lógica pura (sin React/Firebase) para decidir si un registro incompleto
// ("pendiente") puede recuperarse y marcarse como pagado en efectivo desde
// el panel admin. Separado de los componentes para poder razonar/probar la
// regla sin montar nada — mismo criterio que participantValidationLogic.js,
// folioMatrixLogic.js, bulkEditLogic.js.

// Ventana real de una ficha OXXO: 48h desde que se emite (ver
// functions/modules/conektafunctions.js orderOxxoPay(), expire = now +
// 86400*2 segundos). statusPago.fechaPago para una ficha OXXO "pendiente"
// YA es la fecha de emisión (se escribe ahí mismo al crear la orden, no
// solo al confirmarse el pago) — confirmado leyendo statusPagoInscrito()
// en ese mismo archivo.
const HORAS_VENTANA_OXXO = 48;

export function horasDesdeEmisionOxxo(fechaPago) {
  if (!fechaPago) return null;
  const emision = new Date(fechaPago);
  if (isNaN(emision.getTime())) return null;
  return (Date.now() - emision.getTime()) / 3600000;
}

// Único punto de verdad para la UI: calcula si el botón "Recuperar
// registro" debe mostrarse habilitado, deshabilitado (con motivo), u
// ocultarse por completo.
//
// Los registros de grupo (varios atletas, un solo pago) SÍ pueden
// recuperarse acá, cada uno de forma individual — el panel admin no
// gestiona el grupo como tal, así que no hace falta detectar líder/
// seguidor: recuperarRegistroIncompleto ya se encarga de quitar los ítems
// de la orden que lo vinculaban a otro registro antes de guardarlo.
export function puedeRecuperarse(participante) {
  if (!participante || !participante.statusPago) {
    return { puede: false, mostrar: false, motivo: null, disponibleDesde: null };
  }
  if (participante.statusPago.status !== "pendiente") {
    return { puede: false, mostrar: false, motivo: null, disponibleDesde: null };
  }
  if (participante.recuperado) {
    return { puede: false, mostrar: false, motivo: null, disponibleDesde: null };
  }
  if (participante.borrado) {
    return { puede: false, mostrar: false, motivo: null, disponibleDesde: null };
  }

  const esOxxoPendiente = participante.statusPago.formaPago === "oxxo_pay";
  if (esOxxoPendiente) {
    const horas = horasDesdeEmisionOxxo(participante.statusPago.fechaPago);
    if (horas !== null && horas < HORAS_VENTANA_OXXO) {
      const disponibleDesde = new Date(
        new Date(participante.statusPago.fechaPago).getTime() + HORAS_VENTANA_OXXO * 3600000
      );
      return {
        puede: false,
        mostrar: true,
        motivo: "ficha-oxxo-vigente",
        disponibleDesde,
      };
    }
  }

  return { puede: true, mostrar: true, motivo: null, disponibleDesde: null };
}
